module.exports = __webpack_public_path__ + "static/media/hippo2.a23b67b1.gif";